import React, { Component } from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import TopContainer from "../components/TopContainer"
import Footer from "../components/Footer"
import Blocks from "../components/Blocks"
import {
  Group,
  Col,
  Section,
  CtaButton,
  VideoEmbed,
} from "../components/common"

import img from "../images/home-top-bg.jpg"
import img2 from "../images/photo1.jpg"

import imgBackground from "../images/background.png"
import imgTestimonials from "../images/testimonials.png"
import imgTeam from "../images/team.png"
import imgFund from "../images/fund.png"

import imgMoneyPlant from "../images/moneyplant.jpg"

class IndexPage extends Component {
  state = {
    blockData: [
      {
        title: "11,000+",
        subtitle: "Companies",
        color: "#F05E2A",
      },
      {
        title: "74",
        subtitle: "Social Impact Themes",
        color: "#F37043",
      },
      {
        title: "45",
        subtitle: "Frameworks",
        color: "#F37F58",
      },
      {
        title: "300+",
        subtitle: "Social specific indicators & thousands of metrics",
        color: "#F6906E",
      },
    ],
  }

  render() {
    return (
      <>
        <Layout>
          <SEO title="Home" keywords={[]} />
          <div className="page page-home">
            <TopContainer
              titleLines={["We put the S in ESG."]}
              backgroundImage={img}
              body="The S Factor Co. measures companies social impacts in relation to their financial performance."
              ctaText="Learn More"
              ctaLinkTo={"/about"}
            />
            <Section>
              <VideoEmbed vimeoId={"335227720"} />
            </Section>
            <Section>
              <Group>
                <Col size="third">
                  <div className="headingAccent" />

                  <h3>Our Database Covers:</h3>
                </Col>
                <Col size="two-thirds">
                  <Blocks blockData={this.state.blockData} />
                </Col>
              </Group>
            </Section>
            <Section hasDivider={false}>
              <Group>
                <Col size="third">
                  <div className="headingAccent" />

                  <h3>What is The S Factor?</h3>
                </Col>
                <Col size="two-thirds">
                  <img src={img2} style={{ width: "100%" }} />
                  <div style={{ height: 20 }} />
                  <Group>
                    <Col>
                      <p>
                        Sustainable, Responsible and Impact investing (SRI), an
                        investment discipline which considers environmental,
                        social and corporate governance (ESG) criteria to
                        generate long-term competitive financial returns.
                      </p>
                      <p>
                        The S Factors are the Social Factors, most of which are
                        missing or are too “high-level” from current ESG
                        considerations. The social impact factors are our area
                        of subject-expertise, a discipline where we have been
                        working boots-on-the-ground for over two decades
                        measuring specifically social impacts.
                      </p>
                    </Col>
                    <Col>
                      <p>
                        The S Factor Co., is a MacCormick Inc. company,
                        established in 2009. MacCormick created the World’s
                        First, Social Performance Index in 2010. Known as the
                        MSPI, it measures companies’ social impact and risk
                        performance in accordance with dozens of frameworks and
                        hundreds of indicators.
                      </p>
                      <p>
                        The MSPI top performing companies are also boasting
                        superior financial results.
                      </p>
                      <p>
                        <CtaButton linkTo={"s-factor"} dark={true}>
                          More About What We Do
                        </CtaButton>
                      </p>
                    </Col>
                  </Group>
                </Col>
              </Group>
              <div style={{ height: 40 }} />
            </Section>

            <Section dark={true}>
              <div style={{ height: 40 }} />

              <Group>
                <Col size="third">
                  <div className="headingAccent" />

                  <h3>We put the S in ESG</h3>
                </Col>
                <Col size="two-thirds">
                  <p style={{ fontSize: 20, lineHeight: 1.4 }}>
                    The S Factor Score is a proprietary method which maps every
                    social indicator possible to a standardized set of themes.
                    Our unique scoring methodology captures material evidence of
                    company’s management and performance in these areas, at
                    every site of operation.{" "}
                  </p>
                  <p style={{ fontSize: 20, lineHeight: 1.4 }}>
                    The MacCormick Social Performance Index “MSPI” marries the S
                    Factor Score + Financial Performance + Controversies &
                    Sentiment ratings, in order identify the best-in-class for
                    social, financial and public perception returns.{" "}
                  </p>
                  <p style={{ fontSize: 20, lineHeight: 1.4 }}>
                    The S Factor Ratings “ratings” monitors performance in both
                    the score and the index concepts to identify, predict and
                    rate companies risk exposure in social impact issues.
                  </p>
                </Col>
              </Group>
            </Section>

            <Section dark={true} hasDivider={false}>
              <Group>
                <Col size="third">
                  <div className="headingAccent" />
                  <h3>ESG and SRI</h3>
                </Col>
                <Col size="two-thirds">
                  <p style={{ fontSize: 20, lineHeight: 1.4 }}>
                    SRI is an investment discipline that considers ESG criteria
                    to generate long-term competitive financial returns and
                    positive social impact.{" "}
                  </p>
                  <p style={{ fontSize: 20, lineHeight: 1.4 }}>
                    At large, the social metrics and content substantially
                    underrepresented or are non-existent in across the ESG and
                    Impact markets.{" "}
                  </p>

                  <div style={{ height: 20 }} />

                  <img src={imgMoneyPlant} style={{ width: "100%" }} />
                </Col>
              </Group>

              <div style={{ height: 40 }} />
            </Section>

            <Section>
              <div className="headingAccent" />

              <h3>Our Company</h3>
              <Group>
                <Col size="third">
                  <div
                    className="square-graphic"
                    style={{ backgroundImage: `url(${imgBackground})` }}
                  />
                  <h4>Background</h4>
                  <p style={{ height: 72 }}>
                    The S Factor Co. is a subsidiary of MacCormick Inc. (est.
                    2009), a Social Impact Management Consulting firm.
                  </p>
                  <CtaButton linkTo={"about"} dark={true}>
                    More About Us
                  </CtaButton>
                  <p />
                </Col>
                <Col size="third">
                  <div
                    className="square-graphic"
                    style={{ backgroundImage: `url(${imgTestimonials})` }}
                  />
                  <h4>Testimonials</h4>
                  <p style={{ height: 72 }}>
                    It is the most comprehensive and systematic rating system
                    the sector has ever seen.
                    <br />
                    -Sir Mark Moody-Stuart
                  </p>
                  <CtaButton linkTo={"about#testimonials"} dark={true}>
                    More About Us
                  </CtaButton>
                  <p />
                </Col>
                <Col size="third">
                  <div
                    className="square-graphic"
                    style={{ backgroundImage: `url(${imgTeam})` }}
                  />
                  <h4>Team</h4>
                  <p style={{ height: 72 }}>
                    The S Factor Co. is led by a world-class team of global
                    advisors who are sector and subject matter experts.
                  </p>
                  <CtaButton linkTo={"about#team"} dark={true}>
                    More About Us
                  </CtaButton>
                  <p />
                </Col>
              </Group>
            </Section>
            <Section hasDivider={false}>
              <div
                className="wide-graphic"
                style={{ backgroundImage: `url(${imgFund})` }}
              >
                <h4>The S Factor Fund</h4>
                <h5>Launching Soon</h5>
              </div>
            </Section>
          </div>
        </Layout>
      </>
    )
  }
}

export default IndexPage
